import loadable from '@loadable/component'

export const ActionBar = loadable(() => import('./ActionBar'))
export const ActionBarOutline = loadable(() => import('./ActionBarOutline'))
export const ActionBarOutlineItem = loadable(
  () => import('./ActionBarOutlineItem')
)
export const ActionBarRelatedLinks = loadable(
  () => import('./ActionBarRelatedLinks')
)
export const ActionBarWires = loadable(() => import('./ActionBarWires'))
export type { ActionBarProps } from './ActionBar'
